import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useTranslate } from "@refinedev/core";

interface RejectModalProps {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: (rejectionReason: string) => void;
}

export function RejectModal({ open, loading, onClose, onConfirm }: RejectModalProps) {
  const translate = useTranslate();
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    if (!reason.trim()) return;
    onConfirm(reason);
    setReason("");
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{translate("partners.reject.title")}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={3}
          label={translate("partners.reject.reason")}
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{translate("buttons.cancel")}</Button>
        <Button
          variant="contained"
          color="error"
          disabled={!reason.trim() || loading}
          onClick={handleConfirm}
        >
          {translate("partners.reject.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
